import { Avatar } from '@vechaiui/react';
import { Link } from 'react-router-dom';
import { useLocalization } from '@fluent/react';

import { PublicRoute } from '#/constants/page-route';
import { useUser } from '#/hooks';

const UserProfilePanel: React.FC<UserProfilePanelProps> = ({ avatarUri }) => {
  const { l10n } = useLocalization();
  const user = useUser();
  const role = user.roles[0]?.name;

  return (
    <div className="flex items-center">
      <Avatar src={avatarUri} size="3xl" />
      <div className="ml-5">
        <div>{user.username}</div>
        {!!role && (
          <div className="text-sm underline-offset-2 text-neutral-500">{l10n.getString(role)}</div>
        )}
        <Link
          className="text-sm underline underline-offset-2 text-neutral-500"
          to={PublicRoute.Logout}
        >
          {l10n.getString('logout')}
        </Link>
      </div>
    </div>
  );
};
type UserProfilePanelProps = {
  avatarUri?: string;
};

export default UserProfilePanel;
